import { useEffect } from 'react';

export const usePauseOnSessionStopped = (pause: () => void, sessionStopped: boolean) => {
    useEffect(() => {
        if (sessionStopped) {
            pause();
        }
    }, [pause, sessionStopped]);
};
